var Fingerprint2 = require('../vendors/fingerprint2.min');
var scrollAnimate = require("base/components/scrollAnimate");

var replaceReviews = true;
var rateFilter = '';
var avHelpfulCookie = {};


var loadReviews = function() {
  var pagiButton  = $("#AV_pagination_next");

  var pagination  = (pagiButton.attr('data-pagination') ? pagiButton.attr('data-pagination') : 0);
  var idProduct   = pagiButton.attr('data-product');
  var reviewsOrder = $("#reviewsOrder").val();

  $('#netreviews_button').addClass('loading');

  var datas = {
    "page": pagination,
    "product": idProduct,
    "order": reviewsOrder,
    "filter": rateFilter
  }

  if (replaceReviews) {
    $('#netreviews_morereviews').html('<div class="comments_loading"></div>');
  }

  var reviews_url = $("#reviews_url").val();
  $.ajax({
    url: reviews_url,
    type: 'POST',
    data: datas,
    success: function(response) {
      if (replaceReviews) {
        $('#netreviews_morereviews').html(response);
      }
      else {
        $('#netreviews_morereviews').append(response);
        $("#netreviews_button_more_reviews").remove();
        $(".netreviews_pagination_more").removeClass('loading');
      }
      nrLoadCookie();
    }
  });

};

function nrCookie(response){
  if (response.success = 1) {
    if (response.method == 'create') {
      // save cookie
      avHelpfulCookie[response.idProduct] = {};
      avHelpfulCookie[response.idProduct]["vote"] = response.isHelpful;
      avHelpfulCookie[response.idProduct]["fingerPrint"] = response.fingerPrint;
      nrSaveCookie(avHelpfulCookie);
    }
    if (response.method == 'delete') {
      // remove cookie
      if (typeof avHelpfulCookie[response.idProduct] !== "undefined") {
        delete avHelpfulCookie[response.idProduct];
        nrSaveCookie(avHelpfulCookie);
      }
    }
  }
}
function nrSaveCookie(avHelpfulCookie) {
  var expiration_date = new Date();
  expiration_date.setTime(expiration_date.getTime()+(365*24*60*60*1000));
  var cookie_value = JSON.stringify(avHelpfulCookie);
  document.cookie = "netreviews_helpful=" + cookie_value + "; expires=" + expiration_date.toGMTString()+"; path=/";
}

function nrLoadCookie() {
  var name = "netreviews_helpful=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  avHelpfulCookie = {};
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      avHelpfulCookie = JSON.parse(c.substring(name.length, c.length));
    }
  }
  var cookieKeys = Object.keys(avHelpfulCookie);
  var cookieValues = Object.values(avHelpfulCookie);
  var idProduct;
  var i = 0;
  cookieKeys.forEach(function(element){
    $('.netreviews_helpful_block').each(function(){
      idProduct = $(this).children('.js-netreviewsVote').attr('data-id-review-product');
      if(idProduct === element){
        var valeur = cookieValues[i];
        if(valeur.vote == 1){
          $(this).children('.js-netreviewsVote').first().addClass('active');
          $(this).children('.js-netreviewsVote').last().removeClass('active');
        }
        if(valeur.vote == 0){
          $(this).children('.js-netreviewsVote').last().addClass('active');
          $(this).children('.js-netreviewsVote').first().removeClass('active');
        }
        //$(this).addClass('active');
        i = i + 1;
      }
    });
  });
}
function nrHelpfulClick(idReviewProduct,vote,active){
  new Fingerprint2().get(function(result, components){
    // new vote > create
    if (!active) {
      nrCallHelpfulWebservice('create',idReviewProduct,vote,result);
    }
    // vote already sent > delete
    else {
      nrCallHelpfulWebservice('delete',idReviewProduct,vote,result);
    }
  });
}


function nrCallHelpfulWebservice(method,idReviewProduct,vote,fingerPrint){
  var helpful_url = $("#url_helpful").val();
  var datas = {
    "method": method,
    "idReviewProduct": idReviewProduct,
    "vote" : vote,
    "fingerPrint" : fingerPrint,
  }

  $.ajax({
    url: helpful_url,
    type: 'POST',
    data: datas,
    success: function(response) {
      var helpfulUtil = JSON.stringify(response);
      nrCookie(response);
    }
  });
}



function initializeDom() {

  nrLoadCookie();
}

function initializeEvents() {

  $('#AV_productReviews').on('change', '#reviewsOrder', function() {
    rateFilter = '';
    replaceReviews = true;
    $('#AV_pagination_next').attr('data-pagination', '0');
    loadReviews();

  });

  $('#AV_productReviews').on('click', '.show_conversation', function(e){
    $(this).parents('.netreviews_review_part').find('.netreviews_website_answers').toggle('slow').toggleClass('hidden');
    $(this).parents('.netreviews_review_part').find('.netreviews_button_comment').toggle();
  });

  $('.netreviews_global_rating_details').on('click', '.rateFilter', function(e) {
    rateFilter = $(this).attr('data-rate');
    replaceReviews = true;
    $('#AV_pagination_next').attr('data-pagination', '0');
    $('#reviewsOrder').val($('#defaultSort').val());
    loadReviews();
  });

  $('#AV_productReviews').on('click', '.netreviews_pagination_more', function(e) {
    replaceReviews = false;
    $(this).addClass('loading');
    loadReviews();
  });

  $('.js-AV_control').on('click', function() {
    if(!$('#AV_informations').hasClass('js-AV_informations_active')) {
      $('#AV_informations').addClass("js-AV_informations_active");
      $('#AV_informations').fadeIn();
    }
  });

  $('.js-AV_control').on('mouseenter', function() {
    if(!$('#AV_informations').hasClass('js-AV_informations_active')) {
      setTimeout(function(){
        if($("#AV_control:hover").length) {
          $('#AV_informations').addClass("js-AV_informations_active");
          $('#AV_informations').fadeIn();
        }
      },150);
    }
  });

  $('#AV_informations').on('click', function() {
    $('#AV_informations').removeClass("js-AV_informations_active");
    $('#AV_informations').fadeOut();
  });

  $('#AV_productReviews').on('click','.js-netreviewsVote', function(){
    var idReviewProduct = $(this).attr('data-id-review-product');
    var vote = $(this).attr('data-vote');
    var active = $(this).hasClass('active');
    if($(this).attr('id') == 'helpful_yes'){
      if(!active) {
        $(this).addClass('active');
        $(this).parents('.netreviews_helpful_block').find('#helpful_no').removeClass('active');
      }
      else{
        $(this).removeClass('active');
      }
    } else if ($(this).attr('id') == 'helpful_no'){
      if(!active) {
        $(this).addClass('active');
        $(this).parents('.netreviews_helpful_block').find('#helpful_yes').removeClass('active');
      }
      else{
        $(this).removeClass('active');
      }
    }
    nrHelpfulClick(idReviewProduct, vote, active);
  });

  $(".product-detail .js-rating-count").on("click", function() {
    const $netReviewsSection = $("#netreviews_reviews_tab");

    scrollAnimate($netReviewsSection);
  });

}


exports.init = function init () {
  initializeDom();
  initializeEvents();
};